import { http } from '../../../../api/http';
import type { AfectacionGeneral } from '../types/afectaciones';

const ENDPOINT = '/planilla/afectacion';

export class AfectacionesService {
  static async getAll(): Promise<AfectacionGeneral[]> {
    const response = await http.get(ENDPOINT);
    return response.data;
  }

  static async save(afectacion: AfectacionGeneral): Promise<AfectacionGeneral> {
    const response = await http.post(ENDPOINT, afectacion);
    return response.data;
  }

  static async delete(id: number): Promise<void> {
    await http.delete(`${ENDPOINT}/${id}`);
  }
}
